import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { InputLabel } from '@mui/material';

import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  Chip,
  CardHeader,
  InputAdornment,
  Avatar
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import { currentFacilityId, filteredOtherFacilityTypes, REST_API_END_POINT, UNITS } from '../../../constants/Defaultvalues';
import AddTimeAndMaterialProduct from './AddTimeAndMaterialProduct';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { supabase } from '../../../supabase/supabaseClient';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import Modal from '../../_dashboard/blog/ProjectModel';
import JobCost from '../../../pages/dashboard/receipe';


export default function AddProject({ fromSplitEstimate, onClose,productName,RecipeId,splitPercentageFromEstimate,selectedRecipeId,targetFacilityId, modalInhouse, modalIsTrafficCatalog, modalSelectedTab, modalTimeAndMaterial, fromRecipeList }) {
  const location = useLocation()
  // Use modal props if provided (for modal usage), otherwise use router location state
  // This ensures backward compatibility - existing code without modal props continues to work
  const in_house=fromSplitEstimate ? 6 : (modalInhouse !== undefined ? modalInhouse : location.state?.inhouse)
  console.log('in_house------', in_house)
  const timeAndMaterial=modalTimeAndMaterial !== undefined ? modalTimeAndMaterial : location.state?.timeAndMaterial
  const isTrafficCatalog = modalIsTrafficCatalog !== undefined ? modalIsTrafficCatalog : location.state?.isTrafficCatalog
  const selectedTab = fromSplitEstimate ? 'split_catalog' : (modalSelectedTab !== undefined ? modalSelectedTab : location.state?.selectedTab)

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [workflows, setWorkflows] = useState([])
  const [recipe, setRecipe] = useState([])
  const [inHouse, setInHouse] = useState(in_house)
  const [timeMaterial,setTimeMaterial] = useState(timeAndMaterial)
  const currentDate = moment().format('MM-DD-YYYY');
  const [avaTaxCategory, setAvaTaxCategory] = useState([])
  const [otherInstallationSplitInstallLabour, setOtherInstallationSplitInstallLabour] = useState([])
  const [currentInstallationSplitManagementSettings, setCurrentInstallationSplitManagementSettings] = useState([])
  const [splitPercentage, setSplitPercentage] = useState(splitPercentageFromEstimate || 0)
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  // const isEdit =false
  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
    .matches(/^[^\t\n\r:]+$/, 'Name cannot contain colons(:)'),
    // .matches(/^[a-zA-Z0-9\s\-]+$/, 'Name can only contain letters, numbers, spaces, and hyphens')
    
    //  vpt_number:Yup.number().required('Part number is required'),
     vpt_number:Yup.string().required('SKU is required'),
    // price:inHouse && Yup.number().typeError('Please enter a valid price').required('Wholesale Price is required'),
    // price:inHouse && Yup.number().typeError('Please enter a valid price'),
    retail_price:(inHouse || isTrafficCatalog) && selectedTab != 'sub_contract' && Yup.number().typeError('Please enter a valid price').required('Retail Price is required'),
    description: Yup.string().required('Description is required'),
    category: Yup.object().nullable().required('Category is required'),
    unit: Yup.object().nullable(), //.required('Unit is required')
    sub_category: Yup.object().nullable().required('Sub Category is required'),
    workflows: Yup.object().nullable().required('Workflows is required'),
    recipe: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog')&&Yup.object().nullable().required('Product Formula is required'),
    formula_cost: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && Yup.number().required('formula cost is required'),
    markup: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Markup is required').nullable(),
    sub_contract_price: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Price is required').nullable(),
    facility_id: (inHouse == 6 || selectedTab == 'split_catalog' || fromSplitEstimate) ? Yup.object().nullable().required('Facility Type is required') : Yup.object().nullable(),
    lead_time: Yup.number().typeError('Please enter a valid number').nullable(),
    // in_stock_no: Yup.string()
    //   .when([], {
    //     is: () => inHouse === 4,
    //     then: Yup.string().required('Stock is required for Stock Catalogs'),
    //     otherwise: Yup.string().nullable(),
    //   }),
    // start: Yup.date(),
    // end: Yup.date(),
    // avatarUrl: Yup.mixed().required('Product image is required'),
  });
  //

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  //
  const fetchAllProductCategory = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userType = user.user_type
      const userId = user.user_id
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories',{userType,userId})
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            const allCategories = data?.productCategories?.filter((item) => item?.category_type == 1)
            const activeCategories = allCategories?.filter((item) => item.status == 1)
            setCategory(activeCategories)
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }
  }
  const fetchAllRecipe = async () => {
    try {
      axios
        .post(REST_API_END_POINT + 'product/get-all-recipes')
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            const filteredData =  data.recipes.filter((recipe) =>isTrafficCatalog ? recipe?.type === 2 : (fromSplitEstimate || inHouse == 6) ? recipe?.type === 3 : recipe?.type === 1) || data.recipes
            setRecipe(filteredData)
            // Store otherInstallationSplitInstallLabour data
            if (data?.otherInstallationSplitInstallLabour) {
              setOtherInstallationSplitInstallLabour(data?.otherInstallationSplitInstallLabour)
            }
            // Store currentInstallationSplitManagementSettings data
            if (data?.currentFacilitySplitManagementSettings) {
              setCurrentInstallationSplitManagementSettings(data?.currentFacilitySplitManagementSettings)
            }
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }
  }
  const getAllWorkflows = async () => {
    try {
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`)
        .then((res) => {
          setWorkflows(res.data.result)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }
  const fetchAllAvalaraTaxCategories = async()=>{
    try {
       const response = await axios.post(`${REST_API_END_POINT}avalara/get-all-tax-category`);
       console.log("fetchAllAvalaraTaxCategories",response?.data?.result)
       setAvaTaxCategory(response?.data?.result || [])
    } catch (error) {
      console.error('Error fetching Avalara tax categories:', error);
      
    }
  }

  const uploadThumbnailToSupabase = async (file) => {
    try {
      const timestamp = Date.now();
      const sanitizedFileName = file.name.replace(/\s+/g, '_');
      const fileName = `${timestamp}_${sanitizedFileName}`;
      const filePath = `product-thumbnails/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const {
        data: publicUrlData,
        error: urlError,
      } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to generate public URL');
      }

      return publicUrlData.publicUrl;
    } catch (error) {
      console.error('Error uploading thumbnail to Supabase:', error);
      throw error;
    }
  };
  useEffect(() => {
    fetchAllProductCategory()
    getAllWorkflows()
    fetchAllRecipe()
    fetchAllAvalaraTaxCategories()
  }, [])

  const initialUnit = UNITS?.find((data) => data.id === 4);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: fromSplitEstimate ? productName : '',
      vpt_number: '',
      price: '',
      retail_price: '',
      install_cost: '',
      formula_cost: '',
      s_price: '',
      markupPrice: '',
      description: '',
      start: null,
      end: null,
      avatarUrl: null,
      thumbnail: null,
      category: null,
      unit: initialUnit || null,
      unit_qty:1,
      sub_category: null,
      workflows: null,
      recipe: null,
      pf_retail_markup:null,
      isTrafficCatalog:isTrafficCatalog,
      markup :null,
      sub_contract_price: null,
      in_stock_no: '',
      taxCodeId:null,
      taxCode:'',
      facility_id: null,
      install_labour_quantity: 0,
      expected_cost: 0,
      lead_time: '',
      bin_location: ''
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        const user = localStorage.getItem('user')
        const userData = JSON.parse(user)
        if ((values?.unit?.id) && (values?.unit?.id !== 4) && (values?.unit_qty == '')) {
          setFieldError('unit_qty', `Please enter the number of ${values?.unit?.name}`)
        } else {
          values.id = userData.user_id
          values.tags = tags?.join(',')
          if (values.start) {
            values.start = moment(values.start).valueOf() / 1000;

            if (isNaN(values.start)) {
              values.start = '';
            }
          }
          else {
            values.start = '';
          }
          if (values.end) {
            values.end = moment(values.end).valueOf() / 1000;

            if (isNaN(values.end)) {
              values.end = '';
            }
          }
          else {
            values.end = '';
          }
          console.log("############Vaaaaaaaaaa", values.recipe);
          
          // Upload thumbnail to Supabase if selected
          let thumbnail = 'default.jpg'; // Default thumbnail when none is selected
          if (selectedThumbnail) {
            try {
              thumbnail = await uploadThumbnailToSupabase(selectedThumbnail);
            } catch (error) {
              enqueueSnackbar('Failed to upload thumbnail', { variant: 'error' });
              setSubmitting(false);
              return;
            }
          }
          
          const formData = new FormData();
          // let retailPrice = (inHouse === 6 || selectedTab === 'split_catalog') ? values.formula_cost : values.retail_price;
          formData.append("added_by", values.id);
          formData.append("thumbnail", thumbnail);
          formData.append("name", values.name);
          formData.append("vpt_number", values.vpt_number);
          formData.append("description", values.description);
          formData.append("price", values.price);
          formData.append("retail_price", values.retail_price);
          // formData.append("retail_price", retailPrice);
          formData.append("install_cost", values.install_cost);
          formData.append("formula_cost", values.formula_cost);
          // formData.append("s_price", values.recipe?.expected_cost);
          formData.append("s_price", values.recipe?.expected_material_cost_with_markup || 0);

          formData.append("start", values.start);
          formData.append("unit", values.unit.id);
          formData.append("unit_qty", values.unit_qty);
          formData.append("end", values.end);
          formData.append("tags", values.tags);
          formData.append("category", values.category.id);
          formData.append("sub_category", values.sub_category.id);
          formData.append("workflow", values.workflows?.id);
          formData.append("recipe", values.recipe?.id);
          formData.append("inHouse", inHouse);
          formData.append("pf_retail_markup", values.pf_retail_markup);
          formData.append("isTrafficCatalog", values.isTrafficCatalog);
          formData.append("markup", values.markup);
          formData.append("sub_contract_price", values.sub_contract_price);
          formData.append("in_stock_no", values.in_stock_no);
          formData.append("taxCodeId", values.taxCodeId);
          formData.append("taxCode", values.taxCode);
          formData.append("facility_id", values.facility_id?.id || '');
          formData.append("install_labour_quantity", values?.install_labour_quantity || 0);
          formData.append("expected_cost", values?.expected_cost || 0);
          formData.append("lead_time", values.lead_time);
          formData.append("bin_location", values.bin_location || '');
          // Log the key/value pairs
          // console.log("Form data : ");
          // for (var pair of formData.entries()) {
          //   console.log(pair[0] + ' - ' + pair[1]);
          // }
          try {
            const response = await axios.post(`${REST_API_END_POINT}product/add-product`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            // console.log("response.data : ", response.data);
            if (response.data.status === 1) {
              enqueueSnackbar(`Catalog ${values.name} added successfully`, { variant: 'success' });
              
              // Update product_added status if this is from split estimate
              if (fromSplitEstimate && selectedRecipeId) {
                const product_id = response?.data?.product_id || null
                try {
                  await axios.post(`${REST_API_END_POINT}split-estimate/update-product-added-status`, {
                    selectedRecipeId: selectedRecipeId,
                    targetFacilityId: targetFacilityId,
                    product_id : product_id
                  });
                } catch (error) {
                  console.error('Error updating product added status:', error);
                }
              }
            }
            else if (response.data.status === 2) {
              enqueueSnackbar('The Catalog already exist!', { variant: 'error' });
            }
            else if (response.data.status === 0) {
              enqueueSnackbar('Failed to add the Catalog', { variant: 'error' });
            }
            else if (response.data.status === 406) {
              enqueueSnackbar(response.data.status, { variant: 'error' });
            }
            else if (response.data.status === 500) {
              enqueueSnackbar('Server error', { variant: 'error' });
            }
          } catch (error) {
            enqueueSnackbar('Error in adding Catalog', { variant: 'error' });
            console.error("Axios request failed:", error.message);
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
              console.error("Response headers:", error.response.headers);
            } else if (error.request) {
              console.error("No response received. Request details:", error.request);
            } else {
              console.error("Error setting up the request:", error.message);
            }
          }
          resetForm();
          setSubmitting(false);
          
          if ((fromSplitEstimate || fromRecipeList) && onClose) {
            onClose();
          } else {
            // navigate(PATH_DASHBOARD.products.main,{state:{
            //   in_house:inHouse?'in_house':'sub_contract'
            // }});
            navigate(PATH_DASHBOARD.products.main,{state:{
              in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'split_catalog' ? 6 : inHouse ? true : false
        
            }});
          }
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit,handleChange, isSubmitting, setFieldValue, getFieldProps } = formik;

  // Pre-select recipe and facility when fromSplitEstimate or fromRecipeList and IDs are provided
  useEffect(() => {
    if ((fromSplitEstimate || fromRecipeList) && RecipeId && recipe.length > 0) {
      const selectedRecipe = recipe.find(r => r.id === RecipeId);
      if (selectedRecipe) {
        setFieldValue('recipe', selectedRecipe);
        // Trigger the same logic as manual selection
        setFieldValue('s_price', selectedRecipe?.expected_material_cost_with_markup || 0);
        setFieldValue('markupPrice', selectedRecipe?.expected_service_cost_with_markup || 0);
        
        if (selectedRecipe?.expected_cost) {
          const totalRetailCost = inHouse === 6 ? (selectedRecipe?.expected_cost|| 0 ) : ((selectedRecipe?.expected_material_cost_with_markup || 0) + (selectedRecipe?.expected_service_cost_with_markup || 0) + (selectedRecipe?.install_labour_cost_with_markup || 0)) 
          setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
          
          // Calculate expected_cost (without markup)
          const expectedCost = selectedRecipe?.expected_cost || 0;
          setFieldValue('expected_cost', expectedCost);
          
          // Calculate Product cost (Retail) - same logic as the disabled field
          const productCostRetail = (fromSplitEstimate || inHouse == 6) 
            ? totalRetailCost 
            : ((selectedRecipe?.expected_material_cost_with_markup || 0) + (selectedRecipe?.expected_service_cost_with_markup || 0));
          
          // Set Actual Retail Price from Product cost (Retail)
          setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
          
          // Get install labor quantity from recipe services (service_id == 10)
          if (selectedRecipe?.services && Array.isArray(selectedRecipe.services)) {
            const installLaborService = selectedRecipe.services.find(service => service.service_id == 10);
            if (installLaborService && installLaborService.quantity) {
              setFieldValue('install_labour_quantity', installLaborService.quantity);
              // Set Actual Install Price from Install Labor Cost
              // Use expected_install_labor_cost for split catalogs, install_labour_cost_with_markup for others
              // This matches the logic used in manual recipe selection
              if (fromSplitEstimate || inHouse == 6) {
                const installLaborCost = selectedRecipe?.expected_install_labor_cost || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              } else {
                // Set Actual Install Price from Install Labor Cost with markup (for production/traffic catalogs)
                const installLaborCost = selectedRecipe?.install_labour_cost_with_markup || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              }
            }
          }
          
          // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
          if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
            const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
            const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        } else {
          setFieldValue('formula_cost', '')
          setFieldValue('expected_cost', 0)
        }
      }
    }

    // Auto-populate facility when fromSplitEstimate and targetFacilityId are provided
    if (fromSplitEstimate && targetFacilityId && filteredOtherFacilityTypes.length > 0) {
      const selectedFacility = filteredOtherFacilityTypes.find(facility => facility.id === targetFacilityId);
      if (selectedFacility) {
        setFieldValue('facility_id', selectedFacility);
        
        // Filter and set install labor cost when facility is auto-populated
        const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
          item => item.facility_id == targetFacilityId
        );
        
        if (filteredInstallLabour.length > 0) {
          const installLaborCost = filteredInstallLabour[0].total_cost;
          setFieldValue('install_labour_cost_with_markup', installLaborCost);
          
          // Calculate install_cost based on quantity and labor cost
          const quantity = values.install_labour_quantity || 0;
          const totalInstallCost = installLaborCost * quantity;
          setFieldValue('install_cost', totalInstallCost);
        }
        
        // Get split percentage from currentInstallationSplitManagementSettings for split catalog
        const splitSettings = currentInstallationSplitManagementSettings.find(
          setting => setting.id == currentFacilityId
        );
        
        if (splitSettings) {
          const facilitySplitPercentage = splitSettings.split_percentage || 0;
          setSplitPercentage(facilitySplitPercentage);
          
          // Update retail price with split percentage if formula_cost exists
          if (values.formula_cost) {
            const splitAmount = parseFloat(values.formula_cost) * (facilitySplitPercentage / 100);
            const finalRetailPrice = parseFloat(values.formula_cost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        }
      }
    }
  }, [fromSplitEstimate, fromRecipeList, RecipeId, recipe, setFieldValue, splitPercentage, targetFacilityId, filteredOtherFacilityTypes, otherInstallationSplitInstallLabour, currentInstallationSplitManagementSettings, values.install_labour_quantity, values.formula_cost, inHouse])

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedFile(file);
        setFieldValue('avatarUrl', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

  const handleThumbnailDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedThumbnail(file);
        setFieldValue('thumbnail', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

  const UploadImage = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    // console.log("typeof(selectedFile) : ", typeof (selectedFile))
  }
  const handleCategory = async (data) => {
    console.log('data---', data);
    if (data) {
      setFieldValue('category', data)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price', '')
      // setFieldValue('price', '')
      //////////////////////////////////////previos retail and wholesale markup calculation
      // if (data?.markup >= 0) {
      //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
      //   setFieldValue('retail_price', totalRetailCost?.toFixed(2))
      // } else {
      //   setFieldValue('retail_price', '')
      // }
      // if (data?.wholesale_markup >= 0) {
      //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.wholesale_markup / 100)
      //   setFieldValue('price', totalWholesaleCost?.toFixed(2))
      // } else {
      //   setFieldValue('price', '')
      // }
      ///////////////////////////////////////
      // if(values?.price && data?.markup){
      //   const WholesalePrice = Number(values?.price)
      //   const totalRetailCost = WholesalePrice  + (WholesalePrice * data?.markup / 100)
      //   setFieldValue('retail_price',totalRetailCost)
      // }else{
      //   setFieldValue('retail_price','')
      // }
      axios.post(`${REST_API_END_POINT}product/get-subcategory`, { id: data?.id })
        .then((res) => {
          setSubCategory(res.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      setFieldValue('category', null)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price', '')
      // setFieldValue('price', '')
      setSubCategory([])
    }
  }

  const handleSubCategory = async (data)=>{
  if(data){
  setFieldValue('sub_category', data)
  console.log('subcategory',data)
  //////////////////////////////15/01/25 from now the retail markup came from product formula
  // if(data.markup==null && data.wholesale_markup==null){
  //   // setFieldValue('retail_price', '')
  //   // setFieldValue('price', '')
  // }else{

  
  // if (data?.markup >= 0) {
  //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
  //   setFieldValue('retail_price', totalRetailCost?.toFixed(2))
  // } else {
  //   setFieldValue('retail_price', '')
  // }
/////////////////////////////////

  // currently no need of wholesale 14-01-25
  // if (data?.wholesale_markup >= 0) {
  //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.wholesale_markup / 100)
  //   setFieldValue('price', totalWholesaleCost?.toFixed(2))
  // } else {
  //   setFieldValue('price', '')
  // }
// }
  }else{
    setFieldValue('sub_category', null)
    // setFieldValue('retail_price', '')
    // setFieldValue('price', '')
  }

  }
  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setTags([...tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const handleDelete = (tagToDelete) => {
    setTags((prevTags) => prevTags?.filter((tag) => tag !== tagToDelete))
  }

  const handleRecipeCreated = async (newRecipe) => {
    setOpenRecipeModal(false);
    
    // Fetch recipes and find the new one
    try {
      const res = await axios.post(REST_API_END_POINT + 'product/get-all-recipes');
      if (res.data.status === 1) {
        const filteredData = res.data.recipes.filter((recipe) => 
          isTrafficCatalog ? recipe?.type === 2 : (fromSplitEstimate || inHouse == 6) ? recipe?.type === 3 : recipe?.type === 1
        ) || res.data.recipes;
        setRecipe(filteredData);
        
        const newRecipeData = filteredData.find(r => r.id === newRecipe.id);
        if (newRecipeData) {
          setFieldValue('recipe', newRecipeData);
          setFieldValue('s_price', newRecipeData?.expected_material_cost_with_markup || 0);
          setFieldValue('markupPrice', newRecipeData?.expected_service_cost_with_markup || 0);
          
          if (newRecipeData?.expected_cost) {
            const totalRetailCost = inHouse === 6 ? (newRecipeData?.expected_cost || 0) : ((newRecipeData?.expected_material_cost_with_markup || 0) + (newRecipeData?.expected_service_cost_with_markup || 0) + (newRecipeData?.install_labour_cost_with_markup || 0));
            setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2));
            setFieldValue('expected_cost', newRecipeData?.expected_cost || 0);
            
            // Calculate Product cost (Retail) - same logic as the disabled field
            const productCostRetail = (fromSplitEstimate || inHouse == 6) 
              ? totalRetailCost 
              : ((newRecipeData?.expected_material_cost_with_markup || 0) + (newRecipeData?.expected_service_cost_with_markup || 0));
            
            // Set Actual Retail Price from Product cost (Retail)
            setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
            
            // Get install labor quantity from recipe services (service_id == 10)
            if (newRecipeData?.services && Array.isArray(newRecipeData.services)) {
              const installLaborService = newRecipeData.services.find(service => service.service_id == 10);
              if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
                setFieldValue('install_labour_quantity', installLaborService.quantity);
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.expected_install_labor_cost || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              } else if (!fromSplitEstimate && inHouse != 6) {
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.install_labour_cost_with_markup || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              }
            }
            
            // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
            if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
              const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
              const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
              setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
            }
          }
        }
      }
    } catch (error) {
      console.error('Error fetching recipes:', error);
    }
  }

  const handleCancel=()=>{
    if ((fromSplitEstimate || fromRecipeList) && onClose) {
      onClose();
    } else {
      // navigate(PATH_DASHBOARD.products.main,{state:{
      //   in_house:inHouse?'in_house':'sub_contract'
      // }});
      navigate(PATH_DASHBOARD.products.main,{state:{
        in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'split_catalog' ? 6 : inHouse ? true : false

      }});
    }
  }
  return (
    <Page title="Add Catalog | Sign-Wise Solution">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs
            heading=" Add Catalog"
          /></Stack>
          {timeMaterial? 
          <AddTimeAndMaterialProduct timeMaterial={timeMaterial}/>
          :
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>

            <Grid container spacing={3} justifyContent="center" alignItems="center">
               
              {/* <Grid item xs={12} md={4}>
                <Card sx={{ py: 20, px: 3 }}>
                
                  <Box sx={{ mb: 5 }}>
                    <LabelStyle></LabelStyle>
                    <UploadAvatar
                      accept="image/*"
                      file={values.avatarUrl}
                      maxSize={3145728}
                      type="file"
                      onDrop={handleDrop}
                      error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      caption={
                        <Typography
                          variant="caption"
                          sx={{
                            mt: 2,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary'
                          }}
                        >
                          Allowed *.jpeg, *.jpg, *.png, *.gif
                          <br /> max size of {fData(3145728)}
                        </Typography>
                      }
                    />

                    <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                      {touched.avatarUrl && errors.avatarUrl}
                    </FormHelperText>
                    

                  </Box>

                </Card>
              </Grid> */}
              <Grid item xs={12} md={10}>
              <Typography variant='h6' gutterBottom>
                  {/* {inHouse ? "In House" : "Sub Contract"} */}
                    {isTrafficCatalog
                      ? "Traffic Catalog"
                      : inHouse === 5
                        ? "Client Owned Catalog"
                      : inHouse === 4
                      ? "In Stock Catalog"
                      : inHouse === 6
                        ? "Split Catalog"
                        : inHouse
                          ? "Production Catalog"
                          : "Sub Contract"}

                </Typography>
                <Card sx={{ p: 10, margin: 'auto', height: 'fit-content' }}>
                  {/* <FormControlLabel
                    control={
                      <Switch
                        checked={inHouse}
                         onChange={() => { setInHouse(!inHouse) }}
                      />
                    }
                    label={inHouse ? "In House" : "Sub Contract"}
                  /> */}
                  <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        type="text"
                        {...getFieldProps('name')}
                        // value={values.name}
                        // onChange={(name)=>setFieldValue('name',name)}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                      <TextField
                          fullWidth
                          label="SKU"
                          // type="number"
                          {...getFieldProps('vpt_number')}
                          // onKeyDown={(e) => {
                          //   const invalidKeys = ['ArrowUp', 'ArrowDown',  '-', 'e', '+'];
                          //   if (invalidKeys.includes(e.key)) {
                          //     e.preventDefault();
                          //   }
                          // }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                              </InputAdornment>
                            ),
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                            // e.target.value = e.target.value.replace(/[^0-9]/g, '');
                          }}
                          error={Boolean(touched.vpt_number && errors.vpt_number)}
                          helperText={touched.vpt_number && errors.vpt_number}
                        /> 
                      </Stack>
                        
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        required
                        multiline
                        minRows={3}
                        fullWidth
                        label="Description"
                        type="text"
                        {...getFieldProps('description')}
                        // value={values.description}
                        // onChange={(description)=>setFieldValue("description",description)}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />
                    </Stack>
                    
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box sx={{ width: '100%' }}>
                        <LabelStyle>Thumbnail Image</LabelStyle>
                        <UploadSingleFile
                          accept="image/*"
                          fullImage={true}
                          file={values.thumbnail && values.thumbnail !== 'default.jpg' ? values.thumbnail : null}
                          maxSize={3145728}
                          onDrop={handleThumbnailDrop}
                          error={Boolean(touched.thumbnail && errors.thumbnail)}
                          caption={
                            <Typography
                              variant="caption"
                              sx={{
                                mt: 2,
                                mx: 'auto',
                                display: 'block',
                                textAlign: 'center',
                                color: 'text.secondary'
                              }}
                            >
                              Allowed *.jpeg, *.jpg, *.png, *.gif
                              <br /> max size of {fData(3145728)}
                            </Typography>
                          }
                        />
                        <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                          {touched.thumbnail && errors.thumbnail}
                        </FormHelperText>
                      </Box>
                    </Stack>
                    
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') &&
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* <div>
                        <InputLabel htmlFor="material-cost">Select a recipe *</InputLabel> */}
                      <Box sx={{ display: 'flex', gap: 2, width: '100%', alignItems: 'center' }}>
                        <Autocomplete 
                          sx={{ flex: 1 }}
                          id="combo-box-demo"
                          options={recipe}
                          value={values.recipe}
                        // onChange={(event, newValue) => {
                        //   if (newValue) {
                        //     console.log("################Product recipeeeeeeeeeee", newValue);
                        //     setFieldValue('recipe', newValue);
                        //     // setFieldValue('s_price', newValue?.expected_cost);
                        //     setFieldValue('s_price', newValue?.expected_material_cost);

                        //     // setFieldValue('markupPrice',newValue?.expected_material_cost + newValue?.expected_total_service_cost)
                        //     setFieldValue('markupPrice', newValue?.expected_total_service_cost)
                        //     if (newValue?.expected_cost && values?.category?.wholesale_markup >= 0) {
                        //       const totalWholesaleCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + ((newValue?.expected_material_cost) * values?.category?.wholesale_markup / 100)
                        //       setFieldValue('price', totalWholesaleCost.toFixed(2))
                        //       console.log("################Product totalWholesaleCost", totalWholesaleCost);
                        //     } else {
                        //       setFieldValue('price', '')
                        //     }
                        //     if (newValue?.expected_cost && values?.category?.markup >= 0) {
                        //       const totalRetailCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + (((newValue?.expected_material_cost)) * values?.category?.markup / 100)
                        //       console.log("################Product totalRetailCost", totalRetailCost);
                        //       setFieldValue('retail_price', totalRetailCost.toFixed(2))
                        //     } else {
                        //       setFieldValue('retail_price', '')
                        //     }
                        //   } else {
                        //     setFieldValue('recipe', null);
                        //     setFieldValue('s_price', '');
                        //     setFieldValue('price', '');
                        //     setFieldValue('retail_price', '');
                        //   }
                        // }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            console.log("################Product recipeeeeeeeeeee", newValue);
                            setFieldValue('recipe', newValue);
                            // setFieldValue('s_price', newValue?.expected_cost);
                            // setFieldValue('s_price', newValue?.expected_material_cost); previos without markup
                            setFieldValue('s_price', newValue?.expected_material_cost_with_markup || 0);
                            
                           

                            // setFieldValue('markupPrice',newValue?.expected_material_cost + newValue?.expected_total_service_cost)
                            // setFieldValue('markupPrice', newValue?.expected_total_service_cost)
                            setFieldValue('markupPrice', newValue?.expected_service_cost_with_markup || 0)
                            // currently there is no need of markup 14-01-2024
                            // if (newValue?.expected_cost && values?.sub_category?.wholesale_markup >= 0 && values?.sub_category?.wholesale_markup !==null) {
                            //   const totalWholesaleCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + ((newValue?.expected_material_cost) * values?.sub_category?.wholesale_markup / 100)
                            //   setFieldValue('price', totalWholesaleCost.toFixed(2))
                            //   console.log("################Product totalWholesaleCost", totalWholesaleCost);
                            // } else {
                            //   setFieldValue('price', '')
                            // }
                            //previos retail mrkup calculation based on sub cat
                            // if (newValue?.expected_cost && values?.sub_category?.markup >= 0 && values?.sub_category?.markup !==null) {
                            //   const totalRetailCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + (((newValue?.expected_material_cost)) * values?.sub_category?.markup / 100)
                            //   console.log("################Product totalRetailCost", totalRetailCost);
                            //   setFieldValue('retail_price', totalRetailCost.toFixed(2))
                            // } else {
                            //   setFieldValue('retail_price', '')
                            // }

                            if (newValue?.expected_cost) {
                              // const totalRetailCost = inHouse === 6 ? ((newValue?.expected_cost|| 0) - (newValue?.install_labour_cost_with_markup || 0) )  : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0)) 
                              const totalRetailCost = inHouse === 6 ? (newValue?.expected_cost|| 0)  : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0)) 
                              console.log("################Product totalRetailCost", totalRetailCost);
                              setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
                              
                              // Calculate expected_cost (without markup)
                              const expectedCost = newValue?.expected_cost || 0;
                              setFieldValue('expected_cost', expectedCost);
                              
                              // Calculate Product cost (Retail) - same logic as the disabled field
                              const productCostRetail = (fromSplitEstimate || inHouse == 6) 
                                ? totalRetailCost 
                                : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0));
                              
                              // Set Actual Retail Price from Product cost (Retail)
                              setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
                              
                              // Get install labor quantity from recipe services (service_id == 10)
                              if (newValue?.services && Array.isArray(newValue.services)) {
                                const installLaborService = newValue.services.find(service => service.service_id == 10);
                                if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
                                  setFieldValue('install_labour_quantity', installLaborService.quantity);
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.expected_install_labor_cost || 0;
                                  setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                } else if (!fromSplitEstimate && inHouse != 6) {
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.install_labour_cost_with_markup || 0;
                                  setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                }
                              }
                              
                              // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
                              if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
                                const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
                                const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
                                setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
                              }
                            } else {
                              setFieldValue('formula_cost', '')
                              setFieldValue('expected_cost', 0)
                              if (fromSplitEstimate) {
                                setFieldValue('retail_price', '')
                              }
                            }
                          } else {
                            setFieldValue('recipe', null);
                            setFieldValue('s_price', '');
                            setFieldValue('price', '');
                            setFieldValue('formula_cost', '')
                            setFieldValue('pf_retail_markup', '');
                            setFieldValue('markupPrice', '');
                            setFieldValue('expected_cost', 0);
                            if (fromSplitEstimate) {
                              setFieldValue('retail_price', '');
                            }
                          }
                        }}
                        
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth
                            error={Boolean(touched.recipe && errors.recipe)}
                            helperText={touched.recipe && errors.recipe}
                            label='Select a product formula' />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                      {!(fromSplitEstimate || selectedTab === 'split_catalog' || inHouse == 6 || fromRecipeList) ? (
                        <Button
                          variant="outlined"
                          startIcon={<Icon icon={values.recipe ? editFill : plusFill} />}
                          onClick={() => setOpenRecipeModal(true)}
                          sx={{ 
                            mt: 0.5,
                            whiteSpace: 'nowrap',
                            minWidth: 'auto'
                          }}
                        >
                          {values.recipe ? 'Edit Formula' : 'Add Formula'}
                        </Button>
                      ):''}
                      </Box>
                      {/* </div>
                      <div>
                        <InputLabel htmlFor="material-cost">Material Cost</InputLabel> */}
                      {/* <TextField fullWidth
                        // sx={{ width: 310 }}
                        id="material-cost"
                        // label='PFC/Jobcost'
                        label='Material Cost(Retail)'
                        type="text"

                        value={(typeof values?.s_price === 'number') ? values?.s_price.toFixed(2) : ''}
                        onChange={(event, newValue) => {
                          setFieldValue(s_price, newValue)
                        }}
                        disabled={true}
                        error={Boolean(touched.s_price && errors.s_price)}
                        helperText={touched.s_price && errors.s_price}
                      /> */}
                      {/* </div> */}
                    </Stack>}
                    {
                         inHouse == 6 || selectedTab == 'split_catalog' || fromSplitEstimate ? 
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                         <Autocomplete
                           sx={{ width: '100%' }}
                           id="combo-box-demo-type-single"
                           options={filteredOtherFacilityTypes || []}
                           {...getFieldProps('facility_id')}
                           onChange={(event, newValue) => {
                             setFieldValue('facility_id', newValue);
                             
                             // Filter and set install labor cost when facility_id changes
                             if (newValue && (inHouse == 6 || fromSplitEstimate)) {
                               const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
                                 item => item.facility_id == newValue.id
                               );
                               
                               if (filteredInstallLabour.length > 0) {
                                 const installLaborCost = filteredInstallLabour[0].total_cost;
                                 setFieldValue('install_labour_cost_with_markup', installLaborCost);
                                 
                                 // Calculate install_cost based on quantity and labor cost
                                 const quantity = values.install_labour_quantity || 0;
                                 const totalInstallCost = installLaborCost * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               }
                               
                               // Get split percentage from currentInstallationSplitManagementSettings for inHouse == 6 or split_catalog
                               if (inHouse == 6 || selectedTab == 'split_catalog') {
                                 const splitSettings = currentInstallationSplitManagementSettings.find(
                                   setting => setting.id == currentFacilityId
                                 );
                                 
                                 if (splitSettings) {
                                   const facilitySplitPercentage = splitSettings.split_percentage || 0;
                                   setSplitPercentage(facilitySplitPercentage);
                                   
                                   // Update retail price with split percentage if formula_cost exists
                                   if (values.formula_cost) {
                                     const splitAmount = parseFloat(values.formula_cost) * (facilitySplitPercentage / 100);
                                     const finalRetailPrice = parseFloat(values.formula_cost) + splitAmount;
                                     setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
                                   }
                                 }
                               }
                             } else if (!newValue && (inHouse == 6 || fromSplitEstimate)) {
                               // Reset to initial state when facility type is unselected
                               setFieldValue('install_labour_cost_with_markup', null);
                               setFieldValue('install_cost', '');
                               setFieldValue('install_labour_quantity', 0);
                               
                               // Reset split percentage for inHouse == 6 or split_catalog
                               if (inHouse == 6 || selectedTab == 'split_catalog') {
                                 setSplitPercentage(0);
                                 
                                 // Reset retail price if no facility is selected
                                 if (values.formula_cost) {
                                   setFieldValue('retail_price', values.formula_cost);
                                 }
                               }
                             }
                           }}
                           getOptionLabel={(option) => option?.label ?? ''}
                           isOptionEqualToValue={(option, value) => option?.id === value?.id}
                           renderInput={(params) => (
                             <TextField
                               required
                               {...params}
                               label="Choose Facility"
                               placeholder="Select facility"
                               error={Boolean(touched.facility_id && errors.facility_id)}
                               helperText={touched.facility_id && errors.facility_id}
                             />
                           )}
                         />
                       </Stack>
                         : ''
                       }
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') &&<Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* <TextField
                        fullWidth
                        required
                        // label='PFC+Labor markup'
                        // label='Service+Labor markup' previos
                        label='Service Cost(Retail)'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={(typeof values?.markupPrice === 'number') ? values?.markupPrice.toFixed(2) : ''}

                        onChange={(event, newValue) => {
                          setFieldValue('markupPrice', newValue)
                          // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // }
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      /> */}
                      {/* {inHouse !== 6 ? */}
                      <TextField
                        fullWidth
                        required
                        label= 'Product cost (Retail)'
                        id="product_cost_retail"
                        type="text"
                        disabled
                        value={(() => {
                          // For split formulas (fromSplitEstimate or inHouse == 6), use expected_cost
                          if (fromSplitEstimate || inHouse == 6) {
                            return values?.formula_cost ? Number(values.formula_cost).toFixed(2) : '';
                          }
                          
                          // For other formulas, use the original calculation
                          const materialCost = typeof values?.s_price === 'number' ? values.s_price : 0;
                          const serviceCost = typeof values?.markupPrice === 'number' ? values.markupPrice : 0;
                          const totalCost = materialCost + serviceCost;
                          
                          return totalCost > 0 ? totalCost.toFixed(2) : '';
                        })()}
                        error={Boolean(touched.product_cost_retail && errors.product_cost_retail)}
                        helperText={touched.product_cost_retail && errors.product_cost_retail}
                      />
                      {/* :''} */}

                      {(values?.recipe?.install_labour_cost_with_markup > 0 || values?.recipe?.expected_install_labor_cost > 0 ) && (
                        <TextField
                          fullWidth
                          label='Install Labor Cost'
                          id="install_labour_cost"
                          type="text"
                          disabled
                          value={ (fromSplitEstimate || inHouse == 6) ? values?.recipe?.expected_install_labor_cost?.toFixed(2) || '' : values?.recipe?.install_labour_cost_with_markup?.toFixed(2) || ''}
                        />
                      )}

                    </Stack>}
                       {(inHouse == 6 || fromSplitEstimate) ? (
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                           <TextField
                             fullWidth
                             label={`Install Cost (${values.facility_id?.label || 'facility'})`}
                             id="install_labour_cost"
                             type="number"
                             disabled
                             value={values.install_labour_cost_with_markup ? values.install_labour_cost_with_markup.toFixed(2) : ''}
                           />
                           <TextField
                             fullWidth
                             disabled={true}
                             label="Install Labor Quantity"
                             id="install_labour_quantity"
                             type="number"
                             inputProps={{ min: 0 }}
                             value={values.install_labour_quantity}
                             onChange={(event) => {
                               const quantity = parseFloat(event.target.value) || 0;
                               setFieldValue('install_labour_quantity', quantity);
                               
                               // Update install_cost based on quantity and labor cost
                               if (values.install_labour_cost_with_markup) {
                                 const totalInstallCost = values.install_labour_cost_with_markup * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               } else {
                                 // Reset install_cost if no labor cost is set
                                 setFieldValue('install_cost', '');
                               }
                             }}
                             onWheel={(e) => e.target.blur()}
                             onKeyPress={(event) => {
                               if (event.key === '-') {
                                 event.preventDefault();
                               }
                             }}
                           />
                         </Stack>
                       ):''}
                    {
                      !inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' &&
                    
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                       <TextField
                         fullWidth
                         label="Price"
                         type="number"
                         value={values?.sub_contract_price}
                         onChange={(event, newValue) => {
                           setFieldValue('sub_contract_price', event.target.value)
                         }}
                         onWheel={(e)=>e.target.blur()}
                         onKeyPress={(event) => {
                           if (event.key === '0' && event.target.value === '') {
                             event.preventDefault();
                           }
                           if (event.key === '-') {
                             event.preventDefault();
                           }
                          
                         }}
                         error={Boolean(touched.sub_contract_price && errors.sub_contract_price)}
                         helperText={touched.sub_contract_price && errors.sub_contract_price}
                        />

                                <TextField
                                  fullWidth
                                  label="Markup (%)"
                                  value={values?.markup}
                                  onChange={(event, newValue) => {
                                    let value = event.target.value
                                    let markUpData = parseFloat(value).toFixed(2)
                                    setFieldValue('markup', value)
                                  }}
                                  type="number"
                                  onWheel={(e)=>e.target.blur()}
                                  onKeyPress={(event) => {
                                 
                                    if (event.key === '-') {
                                      event.preventDefault();
                                    }
                                  }}
                                  error={Boolean(touched.markup && errors.markup)}
                                  helperText={touched.markup && errors.markup}
                                />


                     </Stack>
                    }
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog')&&
                    <>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* no neeed of wholesale 14-01-25 */}
                      {/* <TextField
                        fullWidth
                        required
                        label='Wholesale Price'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={values.price}
                        onChange={(event, newValue) => {
                          setFieldValue('price', newValue)
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      /> */}
                      {/*  */}
                          {/* // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // } */}
                     

                      <TextField
                        sx={{ width: inHouse == 6 ? '50%' : '100%' }}
                        required
                        label='Formula Cost'
                        id="formula_cost"
                        type="text"
                        disabled
                        value={values?.formula_cost}
                        onChange={(event, newValue) => {
                          setFieldValue('formula_cost', newValue)
                        }}
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.formula_cost && errors.formula_cost)}
                        helperText={touched.formula_cost && errors.formula_cost}
                      />
                      {
                        (inHouse == 6 || fromSplitEstimate) ?
                        <TextField
                           sx={{ width: '50%' }}
                           label="Outgoing Percentage %"
                           id="outgoing_percentage"
                           type="number"
                           disabled
                           value={splitPercentage ? splitPercentage : '0.00'}
                         />
                        :''
                      }
                      {/* <TextField
                        fullWidth
                        required
                        name="retail_price"
                        label='Retail Price'
                        id="retail_price"
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.retail_price}
                        // onChange={(event, newValue) => {
                        //   setFieldValue('retail_price', newValue)
                        // }}
                        onChange={handleChange} 
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                        helperText={touched.retail_price && errors.retail_price}
                      /> */}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        required
                        name="retail_price"
                        label='Actual Retail Price'
                        id="retail_price"
                        disabled={selectedTab === 'split_catalog' || fromSplitEstimate || inHouse == 6}
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.retail_price || ''}
                        // onChange={(event, newValue) => {
                        //   setFieldValue('retail_price', newValue)
                        // }}
                        onChange={handleChange} 
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                        helperText={touched.retail_price && errors.retail_price}
                      />
                        <TextField
                        fullWidth
                        required
                        disabled={selectedTab === 'split_catalog' || fromSplitEstimate || inHouse == 6}
                        name="install_cost"
                        label='Actual Install Price'
                        id="install_cost"
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.install_cost}
                        onChange={handleChange} 
                        error={Boolean(touched.install_cost && errors.install_cost)}
                        helperText={touched.install_cost && errors.install_cost}
                      />
                    </Stack>
                    </>
                    }
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={category || []}
                        value={values.category}
                        onChange={(event, newvalue) => handleCategory(newvalue)}
                        // onChange={(event, newValue) =>setFieldValue('category', newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.category && errors.category)}
                            helperText={touched.category && errors.category}
                            label="Select a category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}

                      />
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={subCategory || []}
                        value={values.sub_category}
                        onChange={(event, newValue) => handleSubCategory(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.sub_category && errors.sub_category)}
                            helperText={touched.sub_category && errors.sub_category}
                            label="Select a Sub Category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      {/* <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={UNITS}
                        value={values.unit}
                        onChange={(event, newValue) => {
                          setFieldValue('unit', newValue)
                          if (newValue && newValue?.id == 4) {
                            setFieldValue('unit_qty', '')
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.unit && errors.unit)}
                            helperText={touched.unit && errors.unit}
                            label="Select a unit" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      /> */}
                      {/* {((values?.unit) && (values?.unit?.id !== 4)) ?
                      <TextField
                        fullWidth
                        label={'Number of '+values?.unit?.name}
                        type="number"
                        onKeyPress={(event) => {
                          // console.log('errorFieldId------',errorFieldId)
                          if (event.key === '0' && event.target.value === '0' ) {
                            event.preventDefault();
                          }
                          if (event.key === '0' && event.target.value === '' ) {
                            event.preventDefault();
                          }
                          if (event.key === '-' ) {
                            event.preventDefault();
                          }
                          if (event.key === '.' ) {
                            event.preventDefault();
                          }
                        }}
                        {...getFieldProps('unit_qty')}                  
                        error={Boolean(touched.unit_qty && errors.unit_qty)}
                        helperText={touched.unit_qty && errors.unit_qty}
                      /> : null } */}
                      <Autocomplete
                        freeSolo
                        multiple
                        fullWidth
                        id="tags-outlined"
                        // options={tags}
                        options={[]}
                        value={tags || []}
                        onChange={(event, newValue) => setTags(newValue)}
                        inputValue={inputValue}
                        onInputChange={handleInputChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Tags"
                            onKeyDown={handleKeyDown}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag}
                              onDelete={() => handleDelete(tag)}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete
                        fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={workflows}
                        value={values.workflows}
                        onChange={(event, newValue) => setFieldValue('workflows', newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a Production Workflow" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}

                      />

                      {/* {(inHouse != 1 && inHouse != 6) && (
                          <TextField
                            fullWidth
                            required
                            label="Stock"
                            {...getFieldProps('in_stock_no')}
                            onChange={(e) => {
                              const numericOnly = e.target.value.replace(/\D/g, '');
                              setFieldValue('in_stock_no', numericOnly);
                            }}
                            error={Boolean(touched.in_stock_no && errors.in_stock_no)}
                            helperText={touched.in_stock_no && errors.in_stock_no}
                          />
                      )} */}

                    </Stack>
                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Project Type"
                    {...getFieldProps('Type')}
                    error={Boolean(touched.Type && errors.Type)}
                    helperText={touched.Type && errors.Type}
                  />
                  <TextField
                    fullWidth
                    label="URL"
                    {...getFieldProps('URL')}
                    error={Boolean(touched.URL && errors.URL)}
                    helperText={touched.URL && errors.URL}
                    InputProps={{
                        endAdornment: (
                          <Link href={getFieldProps('URL').value} target="_blank" rel="noopener noreferrer">
                            
                          </Link>
                        ),
                      }}
                  />
                  <TextField
                    select
                    fullWidth
                    label="Country"
                    placeholder="Country"
                    {...getFieldProps('country')}
                    SelectProps={{ native: true }}
                    error={Boolean(touched.country && errors.country)}
                    helperText={touched.country && errors.country}
                  >
                    <option value="" />
                    {countries.map((option) => (
                      <option key={option.code} value={option.label}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Stack> */}

                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={avaTaxCategory || []}
                        value={avaTaxCategory.find((item) => item.taxCodeId == values.taxCodeId) || null}
                        onChange={(event, newvalue) =>{
                              if(newvalue){
                                setFieldValue('taxCodeId', newvalue.taxCodeId);
                                setFieldValue('taxCode', newvalue.taxCode);
                              }else{
                                setFieldValue('taxCodeId', null);
                                setFieldValue('taxCode', '');
                              }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required
                            // error={Boolean(touched.category && errors.category)}
                            // helperText={touched.category && errors.category}
                            label="Select Avalara Tax Category" />
                        )}
                        getOptionLabel={(option) => option.description ? option.description : ''}

                      />
                     
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                        <TextField
                          sx={{ width: { xs: '100%', sm: ((inHouse === 1 || inHouse === true) && !isTrafficCatalog) ? '100%' : '50%' } }}
                          label="Lead Time (Days)"
                          type="number"
                          value={values?.lead_time || ''}
                          onChange={(event) => {
                            const value = event.target.value;
                            // Allow empty input or positive integers only
                            if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
                              setFieldValue('lead_time', value);
                            }
                          }}
                          onWheel={(e) => e.target.blur()} // prevent accidental scroll changes
                          onKeyPress={(event) => {
                            // Prevent minus or leading zero
                            if (event.key === '-' || (event.key === '0' && event.target.value === '')) {
                              event.preventDefault();
                            }
                          }}
                          inputProps={{ min: 0, step: 1 }}
                          error={Boolean(touched.lead_time && errors.lead_time)}
                          helperText={touched.lead_time && errors.lead_time}
                        />
                        {!((inHouse === 1 || inHouse === true) && !isTrafficCatalog) && (
                          <TextField
                            sx={{ width: { xs: '100%', sm: '50%' } }}
                            label="BIN Location"
                            type="text"
                            value={values?.bin_location || ''}
                            onChange={(event) => {
                              setFieldValue('bin_location', event.target.value);
                            }}
                            error={Boolean(touched.bin_location && errors.bin_location)}
                            helperText={touched.bin_location && errors.bin_location}
                          />
                        )}
                    </Stack>


                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Add Catalog
                      </LoadingButton>
                      <Button variant="outlined" type="submit" onClick={handleCancel} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
}
      </Container>
      
      <Modal
        modalTitle={values.recipe ? "Edit Product Formula" : "Add Product Formula"}
        open={openRecipeModal}
        handleClose={() => setOpenRecipeModal(false)}
        width={1200}
      >
        <JobCost 
          fromSplitEstimate={fromSplitEstimate || false}
          formulaName={values.recipe?.name || null}
          onRecipeCreated={handleRecipeCreated}
          setRecipes={setRecipe}
          formulaTab={(() => {
            let tab = 'production';
            if (isTrafficCatalog) {
              tab = 'traffic';
            } else if (inHouse == 6 || selectedTab === 'split_catalog' || fromSplitEstimate) {
              tab = 'split';
            }
            return tab;
          })()}
          recipeId={values.recipe?.id || null}
          fromAddProductsEdit={true}
        />
      </Modal>
    </Page>
  );
}
